export default "__VITE_ASSET__fFSxaHAh__"